// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZgS-","tabsBox":"styles_tabsBox__3Na4p","createButton":"styles_createButton__2CKut"};